// Atenção!
// Este arquivo é carregado em todas as páginas do site,
// então qualquer código aqui será executado em todas as páginas.
// Se você quiser adicionar código específico para uma página,
//  use o arquivo correspondente em assets/js/pages/

/* -------------------------------------------------------------------------- */
/*                     Verifica se o GSAP está disponível                     */
/* -------------------------------------------------------------------------- */

if (typeof window.gsap !== "undefined") {
  gsap.registerPlugin(ScrollTrigger);

  // gsap.utils.toArray("[data-animate]").forEach((el) => {
  //   gsap.from(el, {
  //     opacity: 0,
  //     y: 50,
  //     duration: 1,
  //     ease: "power3.out",
  //     scrollTrigger: {
  //       trigger: el,
  //       start: "top 85%",
  //       toggleActions: "play none none none",
  //     },
  //   });
  // });
}

/* -------------------------------------------------------------------------- */
/*                          Scripts do Menu Principal                         */
/* -------------------------------------------------------------------------- */

document.querySelectorAll(".menu > .menu-item-has-children").forEach((item) => {
  let timeout;

  item.addEventListener("mouseenter", (e) => {
    e.preventDefault();

    clearTimeout(timeout);

    item.classList.add("active");
  });

  item.addEventListener("mouseleave", () => {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      item.classList.remove("active");
    }, 320);
  });
});

const headerSub = document.querySelector("header .menu-item-has-children .sub-menu");
if (headerSub) {
  const disclaimerImage = document.createElement("div");
  disclaimerImage.classList.add("disclaimer-header");
  disclaimerImage.addEventListener("click", () => {
    window.location.href = window.location.origin + "/contato";
  });
  headerSub.appendChild(disclaimerImage);
}

/* -------------------------------------------------------------------------- */
/*                        Configuração do menu de busca                       */
/* -------------------------------------------------------------------------- */

const searchScreen = document.querySelector(".search-menu");

if (searchScreen) {
  searchScreen.addEventListener("click", (e) => {
    if (e.target.classList.contains("search-menu")) {
      searchScreen.classList.toggle("active");
    }
  });
}

const searchBtn = document.querySelector(".search-btn");
if (searchBtn) {
  searchBtn.addEventListener("click", () => {
    searchScreen.classList.toggle("active");
  });
}

/* -------------------------------------------------------------------------- */
/*                         Configuração do menu Mobile                        */
/* -------------------------------------------------------------------------- */

const menuToggleBtn = document.querySelector(".menu-toggle-btn");

if (menuToggleBtn) {
  menuToggleBtn.addEventListener("click", () => {
    menuToggleBtn.classList.toggle("active");
    document.querySelectorAll(".menu-mobile .active").forEach((activeItem) => {
      activeItem.classList.remove("active");
    });
    document.querySelector(".menu-mobile").classList.toggle("active");
  });
}

/* -------------------------------------------------------------------------- */
/*                               Submenu Mobile                               */
/* -------------------------------------------------------------------------- */

document.querySelectorAll(".menu-mobile > .menu-item-has-children").forEach((item) => {
  const link = item.querySelector("a");
  const submenu = item.querySelector(".sub-menu");
  link.addEventListener("click", (e) => {
    e.preventDefault();
    submenu.classList.toggle("active");
  });
  const voltarBTN = document.createElement("button");
  voltarBTN.classList.add("voltar-btn");
  voltarBTN.addEventListener("click", () => {
    submenu.classList.remove("active");
  });
  voltarBTN.textContent = "Voltar";
  submenu.prepend(voltarBTN);
});

/* -------------------------------------------------------------------------- */
/*                         Checkboxs personalizados                           */
/* -------------------------------------------------------------------------- */

document.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
  const newCheckbox = document.createElement("span");
  newCheckbox.classList.add("c-checkbox");

  // reflect initial state
  if (checkbox.checked) {
    newCheckbox.classList.add("checked");
    checkbox.setAttribute("checked", "checked");
  } else {
    checkbox.removeAttribute("checked");
  }

  // accessibility roles and keyboard support
  newCheckbox.setAttribute("role", "checkbox");
  newCheckbox.setAttribute("tabindex", "0");
  newCheckbox.setAttribute("aria-checked", checkbox.checked ? "true" : "false");

  const toggle = () => {
    checkbox.checked = !checkbox.checked;
    if (checkbox.checked) {
      checkbox.setAttribute("checked", "checked");
    } else {
      checkbox.removeAttribute("checked");
    }
    // bubble so delegated listeners catch it
    checkbox.dispatchEvent(new Event("change", { bubbles: true }));
    newCheckbox.classList.toggle("checked", checkbox.checked);
    newCheckbox.setAttribute("aria-checked", checkbox.checked ? "true" : "false");
  };

  newCheckbox.addEventListener("click", (e) => {
    e.preventDefault();
    toggle();
  });

  newCheckbox.addEventListener("keydown", (e) => {
    if (e.key === " " || e.key === "Enter") {
      e.preventDefault();
      toggle();
    }
  });

  checkbox.parentNode.insertBefore(newCheckbox, checkbox.nextSibling);
});

/* -------------------------------------------------------------------------- */
/*                        Input tipo data personalizado                       */
/* -------------------------------------------------------------------------- */

document.querySelectorAll("input[type='date']").forEach((input) => {
  input.type = "text";
  input.addEventListener("focus", () => {
    input.type = "date";
  });
  input.addEventListener("blur", () => {
    if (!input.value) {
      input.type = "text";
    }
  });
});

window.addEventListener("resize", () => {
  if (typeof swiper !== "undefined") {
    swiper.update();
  }

  if (typeof ScrollTrigger !== "undefined") {
    ScrollTrigger.refresh();
  }

  document.body.style.width = "100%";
});
